import { createClient } from '@supabase/supabase-js';

export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || 'https://cbanszjdonrolhlzuepu.supabase.co';
export const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNiYW5zempkb25yb2xobHp1ZXB1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njk3NzQzMTUsImV4cCI6MjA4NTM1MDMxNX0.G8Y8m-9zSP05e9vaa3CM9EmskQzhtB0_08p-9bLBuIA';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
